export default __webpack_public_path__ + "static/media/combo_bw.c41c2fc0.png";